export interface IEnabled {
    label: string;
    color: string;
    icon: JSX.Element;
}

export interface IEnableSelProps {
    IsEnabled?: boolean;
    truthfulLabel: string;
    falseLabel: string;
}

export enum StatusTypes {
    in_progress = 'Υπό Διεκπεραίωση',
    under_update = 'Επικαιροποίηση',
    successful = 'Ολοκληρωμένη',
    rejected = 'Απορριφθείσα',
    draft = 'Πρόχειρο',
    completed = 'Υποβληθέν'
}
export interface IMultiSelProps {
    status?: StatusTypes;
    labelStatus: string;
}